var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.3333C7.93438 10.3333 9.5 8.76771 9.5 6.83333C9.5 4.89896 7.93438 3.33333 6 3.33333C4.06563 3.33333 2.5 4.89896 2.5 6.83333C2.5 8.76771 4.06563 10.3333 6 10.3333ZM8.4 11.3333H8.14062C7.49063 11.6458 6.76875 11.8333 6 11.8333C5.23125 11.8333 4.5125 11.6458 3.85938 11.3333H3.6C1.6125 11.3333 0 12.9458 0 14.9333V15.8333C0 16.6615 0.671875 17.3333 1.5 17.3333H10.5C11.3281 17.3333 12 16.6615 12 15.8333V14.9333C12 12.9458 10.3875 11.3333 8.4 11.3333ZM15 10.3333C16.6562 10.3333 18 8.98958 18 7.33333C18 5.67708 16.6562 4.33333 15 4.33333C13.3438 4.33333 12 5.67708 12 7.33333C12 8.98958 13.3438 10.3333 15 10.3333ZM16.5 11.3333H16.3812C15.9469 11.4833 15.4875 11.5833 15 11.5833C14.5125 11.5833 14.0531 11.4833 13.6187 11.3333H13.5C12.8625 11.3333 12.275 11.5177 11.7594 11.8146C12.5219 12.6365 13 13.7271 13 14.9333V16.1333C13 16.2021 12.9844 16.2677 12.9812 16.3333H18.5C19.3281 16.3333 20 15.6615 20 14.8333C20 12.899 18.4344 11.3333 16.5 11.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.bdd45073d0a5bb7cdc782df05fea139d.svg";
export { ForwardRef as ReactComponent };